<template>
    <router-view />
</template>

<script>
export default {
    name: 'AuthModule'
};
</script>
